var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import { json } from "@hyper-hyper-space/hhs3_json";
import { formatOpVoidDetail, isVoidCheckable, isVoidCheckableTableOp } from "@hyper-hyper-space/hhs3_rdb";
export function executeLog(bound) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, e_1, _b, _c;
        var _d;
        const dag = yield bound.target.object.getScopedDag();
        const allEntries = [];
        try {
            for (var _e = true, _f = __asyncValues(dag.loadAllEntries()), _g; _g = yield _f.next(), _a = _g.done, !_a; _e = true) {
                _c = _g.value;
                _e = false;
                const entry = _c;
                allEntries.push(entry);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (!_e && !_a && (_b = _f.return)) yield _b.call(_f);
            }
            finally { if (e_1) throw e_1.error; }
        }
        const visible = filterAt(allEntries, bound.at);
        const offset = (_d = bound.ast.offset) !== null && _d !== void 0 ? _d : 0;
        const limited = bound.ast.limit === undefined
            ? visible.slice(offset)
            : visible.slice(offset, offset + bound.ast.limit);
        const rows = [];
        for (const entry of limited) {
            const row = toLogRow(entry);
            const checkable = bound.target.kind === 'table'
                ? isVoidCheckableTableOp(entry.payload)
                : isVoidCheckable(entry.payload);
            if ((bound.target.kind === 'group' || bound.target.kind === 'table') && checkable) {
                row.void = yield bound.target.object.isEntryVoided(entry.hash, bound.from);
                if (bound.explain && row.void === true) {
                    const detail = yield bound.target.object.explainEntryVoided(entry.hash, bound.from);
                    if (detail !== undefined)
                        row.reason = formatOpVoidDetail(detail);
                }
            }
            rows.push(row);
        }
        return {
            kind: 'log',
            target: targetName(bound),
            explain: bound.explain,
            renderContext: yield buildLogRenderContext(bound.target),
            rows,
        };
    });
}
function buildLogRenderContext(target) {
    return __awaiter(this, void 0, void 0, function* () {
        switch (target.kind) {
            case 'group': {
                const group = target.object;
                const groupId = group.getId();
                const groupName = group.getName();
                return {
                    schemaRef: group.getSchemaRef(),
                    groupRef: groupId,
                    groupName,
                    versionScope: { objectId: groupId, objectName: groupName },
                };
            }
            case 'schema': {
                const schema = target.object;
                const schemaName = schema.getName();
                return {
                    schemaRef: schema.getId(),
                    schemaName,
                    versionScope: { objectId: schema.getId(), objectName: schemaName },
                };
            }
            case 'database': {
                const db = target.object;
                const dbId = db.getId();
                const genesis = yield (yield db.getScopedDag()).loadEntry(dbId);
                const databaseName = genesis === undefined
                    ? 'database'
                    : databaseNameFromPayload(genesis.payload);
                return {
                    databaseName,
                    versionScope: { objectId: dbId, objectName: databaseName },
                };
            }
            case 'table': {
                const table = target.object;
                const groupId = table.getGroupId();
                return {
                    groupRef: groupId,
                    tableName: target.tableName,
                    versionScope: { objectId: groupId, objectName: groupId },
                };
            }
        }
    });
}
function databaseNameFromPayload(payload) {
    var _a, _b;
    if (typeof payload !== 'object' || payload === null || Array.isArray(payload))
        return 'database';
    const create = payload;
    return (_b = (_a = create.name) !== null && _a !== void 0 ? _a : create.seed) !== null && _b !== void 0 ? _b : 'database';
}
function filterAt(entries, at) {
    const byHash = new Map(entries.map((e) => [e.hash, e]));
    const reachable = new Set();
    const visit = (hash) => {
        if (reachable.has(hash))
            return;
        const entry = byHash.get(hash);
        if (entry === undefined)
            return;
        reachable.add(hash);
        for (const prev of json.fromSet(entry.header.prevEntryHashes))
            visit(prev);
    };
    for (const hash of at)
        visit(hash);
    return entries.filter((entry) => reachable.has(entry.hash));
}
function toLogRow(entry) {
    return {
        hash: entry.hash,
        fullHash: entry.hash,
        prev: json.fromSet(entry.header.prevEntryHashes),
        payload: entry.payload,
    };
}
function targetName(bound) {
    if (bound.target.kind === 'table')
        return `${bound.target.groupId}.${bound.target.tableName}`;
    return bound.target.id;
}
